import { toTimestamp } from '../utils/addWebSocketToReplication'
import { createReplication } from './createReplication'
import type { UsageCollection } from '../index'

/**
 * Setup replication for workspace usage.
 * Usage metrics are read-only from the client (calculated on backend).
 */
export const setupUsageReplication = (
  collection: UsageCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'usage',
    displayName: 'Usage',
    collection,
    envId,
    useWebSocket: false,
    usePurgeFilter: false,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId ?? envId,
      usage: doc.usage,
      lastCalculated: doc.lastCalculated,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? Date.now(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? Date.now(),
      updatedBy: doc.updatedBy,
      deletedOn: toTimestamp(doc.deletedOn),
      deletedBy: doc.deletedBy,
    }),
    // No mapToServer = read-only (push returns empty array)
  })
